import TableList from 'components/TableList/TableList.component';
import { Stack } from 'styles';
import PaymentsBody from './PaymentsBody.component';
import PaymentsHeader from './PaymentsHeader.component';

const Payments = () => {
	return (
		<Stack width={'100%'} height={`calc(100vh - 280px)`} overflow={'hidden'}>
			<TableList header={<PaymentsHeader />} body={<PaymentsBody />} />
		</Stack>
	);
};

export default Payments;
